import { render, staticRenderFns } from "./charmRiskTab.vue?vue&type=template&id=05831e9c"
import script from "./charmRiskTab.vue?vue&type=script&lang=js"
export * from "./charmRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05831e9c')) {
      api.createRecord('05831e9c', component.options)
    } else {
      api.reload('05831e9c', component.options)
    }
    module.hot.accept("./charmRiskTab.vue?vue&type=template&id=05831e9c", function () {
      api.rerender('05831e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/risk/charmRiskTab.vue"
export default component.exports